import React, { useState, Component } from "react";
import Cross from "../../images/cross.svg";
import { validateImage, compressImage } from "../../helpers/images";
import { Form } from 'react-bootstrap';
import { apiCall } from './../../helpers/api'
import Cropper from './CropperWrapper';

function getImageDimensions(file) {
    return new Promise((resolve, reject) => {
        const img = new window.Image();
        img.onload = () => resolve({ width: img.width, height: img.height });
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
}

export class ImageUploadPreviewComponent extends Component {
 
    constructor(props) {
        super(props)
        this.state = {
            files: this.props.images,
            errors: [],
            draggedFile: null,
            cropping: false,
            cropFile: null,
            crop: { x: 0, y: 0 },
            zoom: 1,
            croppedAreaPixels: null,
            qualityWarning: '',
            hoverImage: null,
        }
        this.previewFiles = this.previewFiles.bind(this)
    }
 
    // Add handler to open cropper for a specific file, but only for new images
    openCropper = (file) => {
        if (!file.new) return; // Prevent cropping of existing images
        this.setState({ cropping: true, cropFile: file, crop: { x: 0, y: 0 }, zoom: 1, croppedAreaPixels: null });
    }

    async previewFiles(e) {
        var errors = [];
        var files = e.target.files;
        var fileArray = this.state.files;
        let lowQualityUrls = [];
        if (files.length + fileArray.length){
            files = Object.entries(files).slice(0,5-fileArray.length).map(file => file[1]);
        }
        for (var file of files) {
            // Check image quality before cropping
            const { width, height } = await getImageDimensions(file);
            const url = URL.createObjectURL(file);
            if (width < 500 || height < 500 || file.size < 50 * 1024) {
                lowQualityUrls.push(url);
                // Still add to preview, but mark as low quality
                var tempFile = {"url":url,"data":file,"metadata":null,"type":"image","new":true,"lowQuality":true};
                fileArray.push(tempFile);
                continue;
            }
            // Add file to preview, cropping will be triggered by clicking preview
            var tempFile = {"url":url,"data":file,"metadata":null,"type":"image","new":true,"lowQuality":false};
            var response = await apiCall(`getUploadSignature?folder=campaignImages&asset_type=${tempFile.type}`,{ "method" : "GET" });
            if (response["success"]) {
                tempFile.metadata = response["success"]["metadata"];
                fileArray.push(tempFile);
            } else {
                errors.push(`An image could not be uploaded: ${response["failure"]["error"]}`);
            }
        }
        this.setState({ files: fileArray, errors: errors })
        this.props.setImages(fileArray)
        this.props.setImagesChanged(true)
    }

    onCropChange = crop => this.setState({ crop });
    onZoomChange = zoom => this.setState({ zoom });
    onCropComplete = (croppedArea, croppedAreaPixels) => this.setState({ croppedAreaPixels });

    cropImage = async () => {
        const { cropFile, croppedAreaPixels, files } = this.state;
        const image = await createImage(cropFile.url || URL.createObjectURL(cropFile));
        const canvas = document.createElement('canvas');
        canvas.width = 500;
        canvas.height = 500;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(
            image,
            croppedAreaPixels.x,
            croppedAreaPixels.y,
            croppedAreaPixels.width,
            croppedAreaPixels.height,
            0,
            0,
            500,
            500
        );
        return new Promise(resolve => {
            canvas.toBlob(async blob => {
                let file = new File([blob], cropFile.data?.name || cropFile.name, { type: 'image/jpeg' });
                file = await compressImage(file, 0.95);
                // Get new upload signature for the cropped image
                var response = await apiCall(`getUploadSignature?folder=campaignImages&asset_type=image`, { method: 'GET' });
                let metadata = cropFile.metadata ? { ...cropFile.metadata } : {};
                if (response && response.success && response.success.metadata) {
                    metadata = { ...metadata, ...response.success.metadata };
                }
                metadata.size = file.size;
                metadata.lastCropped = new Date().toISOString();
                var tempFile = {
                    url: URL.createObjectURL(file),
                    data: file,
                    metadata: metadata,
                    type: cropFile.type || 'image',
                    new: true,
                    lowQuality: cropFile.lowQuality || false
                };
                // Replace the file in the array
                const fileArray = files.map(f => (f.url === cropFile.url ? tempFile : f));
                this.setState({ files: fileArray, cropping: false, cropFile: null });
                this.props.setImages(fileArray);
                this.props.setImagesChanged(true);
                resolve();
            }, 'image/jpeg', 0.95);
        });
    };

    removeFile(targetFile){
        var fileArray = this.state.files.filter(function(file) {return file.url != targetFile.url });
        this.setState({ files: fileArray })
        this.props.setImages(fileArray)
        this.props.setImagesChanged(true)
    }

    setPrimary(targetFile){
        var fileArray = this.state.files.filter(function(file) {return file.url != targetFile.url });
        fileArray.unshift(targetFile);
        this.setState({ files: fileArray })
        this.props.setImages(fileArray)
        this.props.setImagesChanged(true)
    }

    handleDrag(targetFile){
        this.setState({draggedFile: targetFile})
    }
    
    handleDrop(targetFile){
        var newArray = [];
        this.state.files.forEach(file => {
            if (file.url == this.state.draggedFile.url) {
                newArray.push(targetFile)
            }
            else if (file.url == targetFile.url){
                newArray.push(this.state.draggedFile)
            }
            else {
                newArray.push(file)
            }
        })
        this.setState({ files: newArray, draggedFile: null})
    }
 
    render() {
        const hasLowQuality = this.state.files.some(f => f.lowQuality);
        return (
            <>
            {this.state.cropping && (
                <div className="cropper-dialogue" style={{ position: 'fixed', top: '25%', left: '25%', width: '50vw', height: '50vh', background: 'white', zIndex: 9999, boxShadow: '0 0 20px rgba(0,0,0,0.3)', borderRadius: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ width: '100%', height: '80%', position: 'relative' }}>
                        <Cropper
                            image={this.state.cropFile.url || URL.createObjectURL(this.state.cropFile)}
                            crop={this.state.crop}
                            zoom={this.state.zoom}
                            aspect={1}
                            cropShape="rect"
                            showGrid={true}
                            onCropChange={this.onCropChange}
                            onZoomChange={this.onZoomChange}
                            onCropComplete={this.onCropComplete}
                        />
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                        <button className="btn btn-primary me-2" onClick={this.cropImage}>Crop & Save</button>
                        <button className="btn btn-secondary" onClick={()=>this.setState({cropping:false, cropFile:null})}>Cancel</button>
                    </div>
                </div>
            )}
            <div className="form-group multi-preview mt-3">
                {hasLowQuality && (
                    <div className="text-danger mb-2">Some images are low quality</div>
                )}
                {this.state.files.length > 0 && (
                    <span
                        key={this.state.files[0].url}
                        className={`imageWrapper mb-3 position-relative`}
                        draggable={true}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDragStart={e => this.handleDrag(this.state.files[0])}
                        onDrop={e => this.handleDrop(this.state.files[0])}
                        onMouseEnter={() => this.setState({ hoverImage: this.state.files[0].url })}
                        onMouseLeave={() => this.setState({ hoverImage: null })}
                    >
                        <img
                            height="200px"
                            width="200px"
                            className={`me-3 object-fit-cover rounded border ${this.state.files[0].lowQuality ? 'border border-danger border-3' : ''}`}
                            src={this.state.files[0].url}
                            alt="..."
                            style={{ cursor: this.state.files[0].new ? 'pointer' : 'default' }}
                            onClick={() => this.openCropper(this.state.files[0])}
                        />
                        {this.state.files[0].new && this.state.hoverImage === this.state.files[0].url && (
                            <span
                                className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: 40, height: 40, zIndex: 2, boxShadow: '0 1px 4px rgba(0,0,0,0.15)', pointerEvents: 'none' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 16 16">
                                    <path d="M12.146.854a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1 0 .708l-10 10A.5.5 0 0 1 4.793 14H2.5a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l10-10zM11.207 2L3 10.207V13h2.793L14 4.793 11.207 2zm1.586-1.586a1.5 1.5 0 0 0-2.121 0l-10 10A1.5 1.5 0 0 0 1 11.5V14a1 1 0 0 0 1 1h2.5a1.5 1.5 0 0 0 1.06-.44l10-10a1.5 1.5 0 0 0 0-2.12l-2.292-2.293z" fill="#000"/>
                                </svg>
                            </span>
                        )}
                        <img className="overlayTopRight" title="Remove this image from the campaign" onClick={e => this.removeFile(this.state.files[0])} src={Cross}/>
                        <span className="overlayBottomRight">Primary</span>
                    </span>
                )}
                {this.state.files.length > 1 && (this.state.files.slice(1).map(file => (
                    <span
                        key={file.url}
                        className={`imageWrapper mb-3 position-relative`}
                        draggable={true}
                        onDragOver={(ev) => ev.preventDefault()}
                        onDragStart={e => this.handleDrag(file)}
                        onDrop={e => this.handleDrop(file)}
                        onMouseEnter={() => this.setState({ hoverImage: file.url })}
                        onMouseLeave={() => this.setState({ hoverImage: null })}
                    >
                        <img
                            id={file.url}
                            height="200px"
                            width="200px"
                            className={`me-3 object-fit-cover rounded border ${file.lowQuality ? 'border border-danger border-3' : ''}`}
                            src={file.url}
                            alt="..."
                            style={{ cursor: file.new ? 'pointer' : 'default' }}
                            onClick={() => this.openCropper(file)}
                        />
                        {file.new && this.state.hoverImage === file.url && (
                            <span
                                className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: 40, height: 40, zIndex: 2, boxShadow: '0 1px 4px rgba(0,0,0,0.15)', pointerEvents: 'none' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 16 16">
                                    <path d="M12.146.854a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1 0 .708l-10 10A.5.5 0 0 1 4.793 14H2.5a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l10-10zM11.207 2L3 10.207V13h2.793L14 4.793 11.207 2zm1.586-1.586a1.5 1.5 0 0 0-2.121 0l-10 10A1.5 1.5 0 0 0 1 11.5V14a1 1 0 0 0 1 1h2.5a1.5 1.5 0 0 0 1.06-.44l10-10a1.5 1.5 0 0 0 0-2.12l-2.292-2.293z" fill="#000"/>
                                </svg>
                            </span>
                        )}
                        <img className="overlayTopRight" title="Remove this image from the campaign" onClick={e => this.removeFile(file)} src={Cross}/>
                        <button className="btn btn-dark btn-sm overlayBottomLeft" title="Set this image as the primary image" onClick={e => this.setPrimary(file)}>Set Primary</button>
                    </span>
                )))}
                {this.state.errors && (<>{this.state.errors.map((error, idx) => (<p className="text-danger" key={idx}>{error}</p>))}</>)}
            </div>
            <Form.Group className="mb-3 multiUpload">
                <div className="multiUploadBox">Drag & Drop or <a className="text-primary">Upload</a></div>
                <Form.Control disabled={this.state.files.length >= 5} type="file" onChange={this.previewFiles} multiple accept=".png, .jpg, .jpeg, .webp"/>
                {this.state.files.length >= 5 && (
                    <div className="text-danger mt-3">If you'd like to change any photos, please delete one first</div>
                )}
            </Form.Group>
            </>
        )
    }
}

export async function uploadNewImages(images){
    var failedImages = [];
    var campaignImages = [];
    for (const image of images){
        if (image.new) {
            const formData = new FormData();
            formData.append("file",image.data)
            formData.append("public_id",image.metadata.public_id)
            formData.append("api_key",image.metadata.api_key)
            formData.append("timestamp",image.metadata.timestamp)
            formData.append("signature",image.metadata.signature)
            if (image.metadata.folder != ""){
                formData.append("folder",image.metadata.folder)
            }
            campaignImages.push(await fetch(`${image.metadata.target}/${image.metadata.resource_type}/upload`, {
                method: "POST",
                body: formData
            }).then(async response => {
                try {
                    let responseJSON = await response.json();
                    if (response.ok) {
                        return {"id":responseJSON.public_id,"source":image.metadata.source,"name":image.data.name}
                        }
                    else {
                        failedImages.push(image)
                    }
                } catch (error) {
                    failedImages.push(image)
                }
            }))
        }
        else {
            campaignImages.push(image.original)
        }
    }
    return campaignImages;
  }

// Helper to create an HTMLImageElement from a file url
function createImage(url) {
    return new Promise((resolve, reject) => {
        const image = new window.Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', error => reject(error));
        image.src = url;
    });
}